var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.headlinesExist
    ? _c(
        "div",
        {
          staticClass: "carousel-component",
          class: { fullscreen: _vm.fullscreen !== undefined }
        },
        [
          _c(
            "ul",
            _vm._l(_vm.headlines, function(item, i) {
              return _c(
                "li",
                {
                  key: item.idfwheadline,
                  staticClass: "image",
                  class: { show: _vm.isVisible(i) }
                },
                [
                  _c("img", {
                    attrs: {
                      src: item.imageurl,
                      alt: "",
                      onerror: "arguments[0].currentTarget.style.display='none'"
                    }
                  })
                ]
              )
            }),
            0
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35b0c29b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35b0c29b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cdu/headlines/carousel.vue
// module id = null
// module chunks = 